import i18n from 'utils/i18n';
const { t } = i18n;
export enum Status {
  Init = 0,
  InProgress,
  Success,
  Failure,
}

export type ProcessStatusItem = {
  value: string;
  label: string;
  key: string;
  children: { value: number; label: string; hidden?: boolean }[];
};

export const MainStatus = {
  materialSubmission: t('素材提交'),
  manualReview: t('人工审核'),
  preprocessing: t('预处理'),
  intelligentTraining: t('智能训练'),
  assetShelf: t('效果确认'),
  // pushShelf: '推送上架',
};
const processItemSubmit = {
  value: 'SUBMIT',
  label: t('素材提交'),
  key: 'SUBMIT',
  children: [
    { value: Status.Init, label: t('素材提交'), hidden: true },
    { value: Status.InProgress, label: t('素材提交中') },
    { value: Status.Success, label: t('素材提交成功') },
    { value: Status.Failure, label: t('素材提交失败') },
  ],
};
const processItemTrain = {
  value: 'TRAIN',
  key: 'TRAIN',
  label: t('智能训练'),
  children: [
    { value: Status.Init, label: t('待智能训练') },
    { value: Status.InProgress, label: t('智能训练中') },
    { value: Status.Success, label: t('智能训练完成') },
    { value: Status.Failure, label: t('智能训练失败'), hidden: true },
  ],
};
const processItemFinish = {
  value: 'finish',
  key: 'finish',
  label: t('完成'),
  children: [
    { value: Status.Success, label: t('完成') },
    { value: Status.InProgress, label: t('完成'), hidden: true },
    { value: Status.Success, label: t('完成'), hidden: true },
    { value: Status.Failure, label: t('完成'), hidden: true },
  ],
};
export const ProcessStatus = [
  { ...processItemSubmit },
  {
    value: 'AUDIT',
    key: 'AUDIT',
    label: t('人工审核'),
    children: [
      { value: Status.Init, label: t('人工审核'), hidden: true },
      { value: Status.InProgress, label: t('人工审核中') },
      { value: Status.Success, label: t('人工审核通过') },
      { value: Status.Failure, label: t('人工审核未通过') },
    ],
  },
  {
    key: 'PROCESS',
    value: 'PROCESS',
    label: t('预处理'),
    children: [
      { value: Status.Init, label: t('待预处理') },
      { value: Status.InProgress, label: t('预处理中') },
      { value: Status.Success, label: t('预处理完成') },
      { value: Status.Failure, label: t('预处理失败'), hidden: true },
    ],
  },
  {
    ...processItemTrain,
  },
  {
    value: 'CONFIRM',
    key: 'CONFIRM',
    label: t('效果确认'),
    children: [
      { value: Status.Init, label: t('效果待确认') },
      { value: Status.InProgress, label: t('效果确认中') },
      { value: Status.Success, label: t('效果已确认') },
      { value: Status.Failure, label: t('效果确认失败'), hidden: true },
    ],
  },
  {
    ...processItemFinish,
  },
];

export const ProcessStatusCommon = [
  { ...processItemSubmit },
  {
    value: 'AUDIT',
    key: 'AUDIT',
    label: t('授权审核'),
    children: [
      { value: Status.Init, label: t('授权审核'), hidden: true },
      { value: Status.InProgress, label: t('审核中') },
      { value: Status.Success, label: t('审核通过') },
      { value: Status.Failure, label: t('审核未通过') },
    ],
  },
  { ...processItemTrain },
  {
    value: 'CONFIRM',
    key: 'CONFIRM',
    label: t('效果确认'),
    children: [
      { value: Status.Init, label: t('效果待确认') },
      { value: Status.InProgress, label: t('效果确认中') },
      { value: Status.Success, label: t('效果确认通过') },
      { value: Status.Failure, label: t('效果不认可') },
    ],
  },
  {
    value: 'finish',
    key: 'finish',
    label: t('完成'),
    children: [
      { value: Status.Init, label: t('完成'), hidden: true },
      { value: Status.InProgress, label: t('完成'), hidden: true },
      { value: Status.Success, label: t('完成') },
      { value: Status.Failure, label: t('已关单并返还配额') },
    ],
  },
];
export const ProcessStatusPhoto = [
  { ...processItemSubmit },
  {
    value: 'AUDIT',
    key: 'AUDIT',
    label: t('审核'),
    children: [
      { value: Status.Init, label: t('审核'), hidden: true },
      { value: Status.InProgress, label: t('审核中') },
      { value: Status.Success, label: t('审核通过') },
      { value: Status.Failure, label: t('审核未通过') },
    ],
  },
  { ...processItemTrain },
  { ...processItemFinish },
];

export const vhTypeMap = {
  sampleCommon: { label: t('2D小样本（通用口型）'), customType: 2, value: 'IMAGE_GENERAL' },
  sample: { label: t('2D小样本（专属口型）'), customType: 0, value: 'IMAGE' },
  sample4k: { label: t('2D小样本（高精版本）'), customType: 3, value: 'IMAGE_4K' },
  sampleTimbre: { label: t('声音复刻（基础版）'), customType: 1, value: 'VOICE' },
  samplePhoto: { label: t('2D小样本（照片数字人）'), customType: 4, value: 'IMAGE_PHOTO' },
  zeroShotVoice: { label: t('声音复刻（极速版）'), customType: 5, value: 'ZERO_SHOT_VOICE' },
  zeroShotMultiVoice: { label: t('声音复刻（极速版-小语种）'), customType: 7, value: 'ZERO_SHOT_MULTI_VOICE' },
  real_man_3d: { label: t('3D写实'), customType: 6, value: 'real_man_3d' },
  half_realistic_3d: { label: t('3D半写实'), customType: 7, value: 'half_realistic_3d' },
  cartoon_3d: { label: t('3D卡通'), customType: 8, value: 'cartoon_3d' },
  small_sample_2d: { label: t('2D小样本（专属口型）'), customType: 9, value: 'IMAGE' },
};

export const virtualmanTypeMap = {
  small_sample_2d: t('2D小样本（专属口型）'),
  real_man_3d: t('3D写实'),
  cartoon_3d: t('3D卡通'),
  half_realistic_3d: t('3D半写实'),
};
export const deliveryTypeMap = {
  real_man_3d: 1,
  cartoon_3d: 2,
  half_realistic_3d: 3,
  small_sample_2d: 4,
};

export type VirtualmanTypeMap = keyof typeof virtualmanTypeMap;

export type VhType = keyof typeof vhTypeMap;

const filterHiddenItem = (data: ProcessStatusItem[]) => {
  return data.map((item) => {
    const newChildren = item.children.filter((l) => !l.hidden);
    return { ...item, children: newChildren };
  });
};

export const CascaderData = filterHiddenItem([
  ...ProcessStatus,
  {
    value: 'END',
    key: 'END',
    label: t('人工终止'),
    children: [{ value: Status.Failure, label: t('人工终止') }],
  },
]);
export const CascaderDataCommon = filterHiddenItem([
  ...ProcessStatusCommon,
  {
    value: 'END',
    key: 'END',
    label: t('人工终止'),
    children: [{ value: Status.Failure, label: t('人工终止') }],
  },
]);
export const CascaderDataPhoto = filterHiddenItem([...ProcessStatusPhoto]);

export const ProcessStatusVoice = [
  { ...processItemSubmit },
  {
    value: 'TRAIN',
    key: 'TRAIN',
    label: t('智能训练'),
    children: [
      { value: Status.Init, label: t('待智能训练') },
      { value: Status.InProgress, label: t('智能训练中') },
      { value: Status.Success, label: t('智能训练完成') },
      { value: Status.Failure, label: t('智能训练失败') },
    ],
  },
  {
    ...processItemFinish,
  },
];

export const CascaderDataVoice = filterHiddenItem([...ProcessStatusVoice]);

export function generateStatusRes(data: [string, number?][], customType: number) {
  const res: { stage: string; state: Status[] }[] = [];
  const finishKey = customType === 4 || customType === 5 || customType === 7 ? 'TRAIN' : 'CONFIRM';
  data.forEach((item) => {
    const processKey = item?.[0] && item?.[0] === 'finish' ? finishKey : item?.[0];
    const existItem = res.find((i) => i.stage === processKey);
    if (item.length === 1) {
      if (processKey === 'END') {
        res.push({
          stage: 'END',
          state: [],
        });
      }
      // const ProcessStatusList = customType === 2 ? [...ProcessStatusCommon] : [...ProcessStatus];
      let ProcessStatusList = [];
      if (customType === 2) {
        ProcessStatusList = [...ProcessStatusCommon];
      } else if (customType === 5 || customType === 7) {
        ProcessStatusList = [...ProcessStatusVoice];
      } else {
        ProcessStatusList = [...ProcessStatus];
      }
      // 全选
      const processStatusItem = ProcessStatusList.find((p) => p.value === processKey);
      if (processStatusItem) {
        let showState = processStatusItem?.children.filter((i) => !i.hidden).map((i) => i.value);
        if (item?.[0] === 'finish') {
          showState =
            ProcessStatusList.find((p) => p.value === 'finish')
              ?.children.filter((i) => !i.hidden)
              .map((i) => i.value) || [];
        }
        if (existItem) {
          existItem.state = [...new Set([...existItem.state, ...showState])];
        } else {
          res.push({
            stage: processKey,
            state: showState,
          });
        }
      }
    } else if (item.length === 2 && typeof item[1] === 'number') {
      if (existItem) {
        existItem.state = [...new Set([...existItem.state, item[1]])];
      } else {
        res.push({
          stage: processKey,
          state: [item[1]],
        });
      }
    } else {
      console.error(t('数据结构错误'), data);
    }
  });
  return res;
}
